import { useState } from "react";
import { Loader2, Quote } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const field = "w-full bg-navy-950/60 border border-gold-500/12 rounded-lg px-3 py-2 font-read text-sm text-slate-100 outline-none focus:border-gold-400/60";

// Optional back-cover endorsement. Only real quotes the author has permission to use; KLYR never invents one.
export const EndorsementEditor = ({ book, onSaved }) => {
  const m = book.marketing || {};
  const [quote, setQuote] = useState(m.endorsement || "");
  const [by, setBy] = useState(m.endorsement_by || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const updated = await api.setEndorsement(book.id, quote.trim(), by.trim());
      onSaved?.(updated);
      toast.success(quote.trim() ? "Endorsement added to the back cover" : "Endorsement removed");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="endorsement-editor" className="md:col-span-2 bg-navy-950/50 border border-gold-500/12 rounded-xl p-4 space-y-2">
      <div className="flex items-center gap-1.5 font-ui text-[11px] uppercase tracking-widest text-slate-400/80">
        <Quote className="w-3.5 h-3.5" /> Endorsement (optional, back cover)
      </div>
      <textarea data-testid="endorsement-quote-input" rows={2} maxLength={300} value={quote} onChange={(e) => setQuote(e.target.value)}
        placeholder="A real quote you have permission to use" className={field} />
      <div className="flex gap-2">
        <input data-testid="endorsement-by-input" maxLength={80} value={by} onChange={(e) => setBy(e.target.value)}
          placeholder="Who said it (e.g. Jane Doe, bestselling author of …)" className={field} />
        <button data-testid="endorsement-save-button" onClick={save} disabled={busy}
          className="klyr-btn-metal font-ui text-sm font-semibold rounded-lg px-4 py-2 transition-[filter] disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}
        </button>
      </div>
    </div>
  );
};
